import React from 'react';
import PropTypes from 'prop-types';
import css from './DoYouHaveQuestionsBlock.module.scss';
import LinkButton from '../Models/LinkButton/LinkButton';
import CategoriesNavigation from "components/CategoriesNavigation";

const DoYouHaveQuestionsBlock = ({
    heading,
    introHtml,
    categories,
}) => (
    <div className={css.block}>
        {heading && <h2 className={css.heading}>{heading}</h2>}
        {introHtml && <div className={css.intro} dangerouslySetInnerHTML={{ __html: introHtml }} />}
        {categories &&
            <CategoriesNavigation categories={categories} />
        }
    </div>
);

DoYouHaveQuestionsBlock.propTypes = {
    heading: PropTypes.string.isRequired,
    introHtml: PropTypes.string,
    categories: PropTypes.arrayOf(
        PropTypes.shape(LinkButton.propTypes)
    )
};

export default DoYouHaveQuestionsBlock;



// WEBPACK FOOTER //
// ./src/components/DoYouHaveQuestionsBlock/DoYouHaveQuestionsBlock.jsx